import { render, staticRenderFns } from "./GuardCodeShowDetailsTab.vue?vue&type=template&id=92926612"
import script from "./GuardCodeShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./GuardCodeShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports